import { render, staticRenderFns } from "./card-icon.vue?vue&type=template&id=3afa7a3c&"
import script from "./card-icon.vue?vue&type=script&lang=js&"
export * from "./card-icon.vue?vue&type=script&lang=js&"
import style0 from "./card-icon.vue?vue&type=style&index=0&id=3afa7a3c&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports